import React, { FC, useEffect, useState } from 'react';
import { DatePicker, DatePickerProps } from '@mui/x-date-pickers/DatePicker';
import { DesktopDatePicker, DesktopDatePickerProps } from '@mui/x-date-pickers/DesktopDatePicker';
import { MobileDatePicker, MobileDatePickerProps } from '@mui/x-date-pickers/MobileDatePicker';

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';

type CombinedDatePickerProps = DatePickerProps<any, any> | DesktopDatePickerProps<any, any> | MobileDatePickerProps<any, any>;

type IGenericDatePickerProps = {
  DatePickerComponent: typeof DatePicker | typeof DesktopDatePicker | typeof MobileDatePicker,
} & CombinedDatePickerProps;

export const GenericDatePicker: FC<IGenericDatePickerProps> = props => {
  const { DatePickerComponent, ...datePickerProps } = props;
  const [value, setValue] = useState<any>(props.value);

  useEffect(() => {
    setValue(props.value);
  }, [props.value]);

  const handleChange = (newValue: any) => {
    setValue(newValue);
    props?.onChange(newValue);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
      <DatePickerComponent
        {...datePickerProps} 
        value={value} 
        onChange={handleChange} 
      />
    </LocalizationProvider>
  );
};